<template>
  <div>
    <NewCharity v-if="charity_id" mode="edit" :charity_id="charity_id"></NewCharity>
  </div>
</template>

<script>
  import NewCharity from './NewCharity'

  export default {
    name: "EditCharity",
    components: {NewCharity},
    data() {
      return {
        charity_id: "",
      }
    },
    created() {
      this.charity_id = this.$route.params.id;
    },
  }
</script>

<style scoped>

</style>